// extracted by mini-css-extract-plugin
var _1 = "ConfirmationActionsStyle-module__action-button___LKqZN";
var _2 = "ConfirmationActionsStyle-module__action-button--red___orqaX";
var _3 = "ConfirmationActionsStyle-module__action-button___LKqZN";
var _4 = "ConfirmationActionsStyle-module__action-button--red___orqaX";
var _5 = "ConfirmationActionsStyle-module__confirmation-actions___o_6Uc";
var _6 = "ConfirmationActionsStyle-module__confirmation-actions___o_6Uc";
export { _1 as "action-button", _2 as "action-button--red", _3 as "actionButton", _4 as "actionButtonRed", _5 as "confirmation-actions", _6 as "confirmationActions" }
